import React from 'react'
import { Box } from '@material-ui/core'
import { useStyles } from './styles'
import { ImagesSection } from '../'
import Button from 'web/src/app/root/components/common/button'
import Input from 'web/src/app/root/components/common/input'

export const CommentCardAdd = ({
    addComment,
    commentId,
    setCommentText,
    commentText,
    locale,
    imagesForUpload,
    setImagesForUpload,
    deletedPictureKeys,
    setDeletedPictureKeys,
    isEdit,
    postComment,
    report,
    setAddComment,
    setIsEdit,
    isReplaceTypeModal = false
}) => {
    const classes = useStyles()

    return addComment && !commentId ? (
        <Box
            style={{
                paddingBottom: 15
            }}
        >
            <Box className={classes.textareaSection}>
                {!isReplaceTypeModal ? (
                    <Box className={classes.detailsNameColumn}></Box>
                ) : null}
                <Input
                    multiline={true}
                    rows={4}
                    className={classes.textareaInput}
                    setValue={setCommentText}
                    value={commentText}
                    placeholder={locale.reports.enterCommentPlaceholder}
                    style={{ display: 'block' }}
                />
            </Box>
            <Box
                style={{
                    width: isReplaceTypeModal ? '100%' : '50%',
                    marginLeft: 'auto'
                }}
            >
                <ImagesSection
                    imagesForUpload={imagesForUpload}
                    setImagesForUpload={setImagesForUpload}
                    deletedPictureKeys={deletedPictureKeys}
                    setDeletedPictureKeys={setDeletedPictureKeys}
                    isEdit={isEdit}
                />
            </Box>
            {!isReplaceTypeModal ? (
                <Box className={classes.buttonsWrapper}>
                    <Button
                        className={classes.saveButton}
                        onClick={() => postComment(commentText, report)}
                    >
                        {locale.reports.save}
                    </Button>
                    <Button
                        reverted
                        style={{ marginLeft: '10px' }}
                        sign
                        className={classes.saveButton}
                        onClick={() => {
                            setImagesForUpload([])
                            setAddComment(false)
                            setIsEdit(false)
                        }}
                    >
                        {locale.reports.cancle}
                    </Button>
                </Box>
            ) : null}
        </Box>
    ) : null
}
